import { useMemo } from 'react';
import { useTranslate } from '@prenuvo/halo';

import { useStudyGuard } from '@/shared/guard';

import { extractSkuFromSkuId, getSkuPackage } from '../../util';
import { getPatientDisplayName, getPatientDob, getServiceInfoNameList } from './header.util';

export function usePatientPermissionsAndDetails() {
  const translate = useTranslate();
  const {
    isPoetryStudy,
    patient,
    radiologistScan: { machineID, poetryMetadata, skuID },
    studyId,
  } = useStudyGuard();
  const skuPackage = isPoetryStudy
    ? `${getServiceInfoNameList(poetryMetadata?.servicesInfo ?? []).join(', ')}`
    : getSkuPackage(extractSkuFromSkuId(skuID));
  const patientDisplayDob = getPatientDob(patient, translate);
  const patientPrenuvoID = patient.prenuvoID.replace('auth0|', '');
  const patientDisplayName = getPatientDisplayName(
    patient,
    translate('FCT.REPORTING.HEADER.PATIENT.UNKNOWN_NAME'),
  );
  const truncatedPatientID = `${patientPrenuvoID.slice(0, 6)}...`;
  const identifier = poetryMetadata?.accessionNumber || `${studyId.slice(0, 8)}`;
  const showAlias = !machineID?.startsWith('aus-') && !machineID?.startsWith('eng-');

  const value = useMemo(
    () => ({
      identifier,
      patientDisplayDob,
      patientDisplayName,
      patientPrenuvoID,
      showAlias,
      skuPackage,
      truncatedPatientID,
    }),
    [
      identifier,
      skuPackage,
      patientDisplayDob,
      patientPrenuvoID,
      patientDisplayName,
      showAlias,
      truncatedPatientID,
    ],
  );

  return value;
}
